<template>
    <div style="height:100%;">
        <header>
            <nav class="navbar navbar-inverse">
                <div class="container">
                    <router-link to="/cart" class="cart pull-right hidden-xs hidden-sm">
                        <cart-bag></cart-bag>
                    </router-link>
                    <div class="navbar-header">
                        <button v-on:click="openExpander" type="button" id="nav-expander" class="navbar-toggle nav-expander">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <router-link to="/cart" class="cart pull-right hidden-md hidden-lg">
                            <cart-bag></cart-bag>
                        </router-link>
                        <router-link to="/">
                            <a class="navbar-brand"><img src="images/logo.png" alt=""></a>
                        </router-link>
                    </div>
                    <div class="main-menu text-center">
                        <ul class="nav navbar-nav">
                            <li class="nav-close hidden-md hidden-lg">
                                <a v-on:click="closeExpander" id="nav-close">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </a>
                            </li>
                            <router-link exact to="/" tag="li" active-class="active">
                                <a>Home</a>
                            </router-link>
                            <router-link to="/about" tag="li" active-class="active">
                                <a>About</a>
                            </router-link>
                            <router-link to="/shop" tag="li" active-class="active">
                                <a>Shop</a>
                            </router-link>
                            <router-link to="/stories" tag="li" active-class="active">
                                <a>Stories</a>
                            </router-link>
                            <router-link to="/faq" tag="li" active-class="active">
                                <a>FAQ</a>
                            </router-link>
                            <router-link to="/contact" tag="li" active-class="active">
                                <a>Contact</a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>

        <router-view></router-view>

        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <p>&copy; 2017 <img src="images/frs-logo.png" alt=""> <a href="#">Fund Raisers Sports</a>. All Rights Reserved.</p>
                    </div>
                    <div class="col-sm-6">
                        <ul class="social list-inline">
                            <li><a href="https://www.facebook.com/fundraiserssports/"><i class="fa fa-facebook fa-2x"></i></a></li>
                            <li><a href="https://twitter.com/TeamFundRaisers"><i class="fa fa-twitter fa-2x"></i></a></li>
                            <li><a href="https://www.instagram.com/fundraiserssports/"><i class="fa fa-instagram fa-2x"></i></a></li>
                            <li><a href="https://www.pinterest.com/fundraiserssports/"><i class="fa fa-pinterest-p fa-2x"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
        <inscription-guidelines-popup></inscription-guidelines-popup>
        <inscription-examples-popup></inscription-examples-popup>
        <terms-conditions-popup></terms-conditions-popup>
        <fedex-validator></fedex-validator>
    </div>
</template>

<script type="text/jsx">
    import { mapMutations } from 'vuex'
    import CartBag from '@/components/cart/CartBag'
    // popups
    import InscriptionGuidelines from '@/components/content/InscriptionGuidelines.vue';
    import InscriptionExamples from '@/components/content/InscriptionExamples.vue';
    import TermsConditions from '@/components/content/TermsConditions.vue';
    import FedexValidator from '@/components/elements/fedex-validator.vue'
    export default {
        name: 'app',
        mixins: [
        ],
        data: function () {
            return this.getDefaultData();
        },
        components: {
            'cart-bag': CartBag,
            'inscription-guidelines-popup': InscriptionGuidelines,
            'inscription-examples-popup': InscriptionExamples,
            'terms-conditions-popup': TermsConditions,
            'fedex-validator': FedexValidator
        },
        created: function () {
            this.fetchData();
        },
        mounted: function () {
            this.$router.afterEach((to, from) => {
                // console.log('ROUTER:', to, from);
                if (this.navExpanderOpen) {
                    this.closeExpander();
                    // window.scrollTo(0, 0);
                } else if (this.$mq.below(993)) {
                    // window.scrollTo(0, 0);
                }
                window.scrollTo(0, 0);
            });
        },
        beforeDestroy: function () {
        },
        watch: {
            navExpanderOpen: function (newVal) {
                var className = 'nav-expanded';
                if (newVal) {
                    document.body.classList.add(className);
                } else {
                    document.body.classList.remove(className);
                }
            }
        },
        methods: {
            getDefaultData: function () {
                return {
                }
            },

            // mobile navigation menu
            ...mapMutations(['openExpander', 'closeExpander']),

            fetchData: function () {
                /* global FRS_CAMPAIGN, FRS_API_HOST */
                var endpoint = window.location.protocol + FRS_API_HOST + '/api/campaign/' + FRS_CAMPAIGN;
                this.$http.get(endpoint).then(function(response) {
                    var data = response.body || {};
                    this.$store.commit('initAllFromApi', data);
                }, function(error) {
                    console.log('Err:', error);
                });
            }
        },
        computed: {
            navExpanderOpen: function () {
                return this.$store.state.navExpanderOpen
            }
        }
    }
</script>

<style lang="css">
    [v-cloak] {
        display: none;
    }
    .pointer {
        cursor: pointer;
    }
    .validated {
        color: green;
    }
    .no-select {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
    }
    label.has-error:before {
        border: 1px solid #8b0000;
    }
    [type="checkbox"].check-style + label.has-error:before {
        border: 1px solid #8b0000;
    }
    .modal-open {
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// App.vue?132f3a52